import React from 'react';
import SMConst from 'lib/SMConst';
import SMMasterResource from 'resources/SMMasterResource';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMRoomResource from 'resources/SMRoomResource';

class SMRoomInquiryFormView extends React.Component {

  constructor(props) {
    super(props);
    
    this.canRequest = true;
    this.state = {
      capacities: [],
      reservation: null,
      errors: {},
    };
    this.requestParams = this.props.requestParams;
  }

  componentDidMount() {
    $(".js-inquiry-datepicker").datepicker({
      minDate: 0,
      dateFormat:"yy/mm/dd", 
      onClose:function(e){
      
      }
    });
    SMMasterResource.getCapacities((capacities, error, xhr)=>{
      this.setState({capacities: capacities});
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
      
      $(this.refs.priceSlider).slider({
        range: true,
        min: 10000,
        max: 1000000,
        step: 10000,
        values: [0, 1000000],
        slide: (event, ui)=>{
          $(this.refs.minPrice).val(ui.values[0]);
          $(this.refs.maxPrice ).val(ui.values[1]);
        }
      });
      SMTrackHelper.pageView(location.pathname + "/inquiry/new");
      mixpanel.track("Inquiry Form", {"Platform" : "Web",});
    }
  }
  
  dismiss(e) {
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.inquiryFormViewDidClose === 'function'){
        this.props.delegate.inquiryFormViewDidClose();
      }
    }
  }
  
  formDidSubmit(e) {
    if (!this.canRequest) return; 
    this.canRequest = false;
    e.preventDefault();
    const room = this.props.room;
    let formData = new FormData(this.refs.form);
    if (this.refs.startedAt.value && this.refs.endedAt.value) {
      const startedAt = new Date(this.refs.startedAt.value);
      const endedAt = new Date(this.refs.endedAt.value);
      const duration = (endedAt.getTime() - startedAt.getTime()) / 1000 / 60;
      startedAt.setTime(startedAt.getTime() + room.space.utc_offset * 1000);
      formData.append('reserved_schedules[][started_at]', startedAt.toISOString());
      formData.append('reserved_schedules[][duration]', duration);
    }
    
    SMRoomResource.inquiry(room.uid, formData, (reservation, error, xhr)=>{
      if (error) {
        this.canRequest = true;
        switch (xhr.status) {
          case 400: 
            const errorsArray = xhr.responseJSON.errors;
            let errors = {};
            errorsArray.forEach((error)=>{
              errors[error.field] = error.message;
            });
            this.setState({errors: errors});
            break;
          case 409: 
            window.alert("既に予約が入っている日程です。");
            break;
          case 500: 
            break;
        }
      } else {
        SMAppHelper.redirectTo(
          Routes.sent_space_room_inquiry_path(room.space.username, room.uid, reservation.uid)
        );
      }
    });
  }
  
  renderFormItemError(name) {
    const message = this.state.errors[name];
    if (message) { 
      return(
        <p className="popup-form__required"><i className="fa fa-exclamation-circle"></i>{message}</p>
      );
    }
    return null;
  }
  
  eventTypeDidChange(e) {
  }
  
  useTypeDidChange(e) {
  }
  
  capacityDidChange(e) {
  }
  
  contentDidChange(e) {
  }
  
  renderEventTypeOptions(room) {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    room.event_types.forEach((eventType, i)=>{
      rows.push(
        <option key={i} value={eventType.name}>{eventType.name_text}</option>
      );
    });
    return rows;
  }
  
  renderUseTypeOptions(room) {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    const useTypesData = [
      {value:SMConst.ReservationUseType.Indivisual, label: I18n.t("service.label_000048")},
      {value:SMConst.ReservationUseType.Corporate, label: I18n.t("service.label_000049")}
    ];
    useTypesData.forEach((useType, i)=>{
      rows.push(
        <option key={i} value={useType.value}>{useType.label}</option>
      );
    });
    return rows;
  }
  
  renderCapacitySelect(room) {
    let rows = [
      <option key="none" value="">{I18n.t("service.label_000047")}</option>
    ];
    this.state.capacities.forEach((capacity, i)=>{
      rows.push(
        <option key={i} value={capacity.name}>{capacity.name_text}</option>
      );
    });
    return rows;
  }
  
  isInquiryOnly(room) {
    if(this.props.delegate && typeof this.props.delegate.isInquiryOnly === 'function'){
      return this.props.delegate.isInquiryOnly(room);
    }
  }
  
  render() {

    const room = this.props.room;

    const inquiryToRequestMessage = this.isInquiryOnly(room) ? null : <p className="popup-form__text">日時が決まっている場合は<a href={Routes.space_room_reservations_path(room.space.username, room.uid)}>予約リクエスト</a>をした方がやりとりがスムーズです。</p>;
    return(
      <div>
        <div className="md-modal md-effect-101" ref="modal">
    			<div className="md-content">
            <div className="page__popup">
              <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
                <div className="page__popup-col1">
                  <p className="page__popup__cancel search-change__cancel"><a className="md-close" onClick={this.dismiss.bind(this)} href="#"><span className="page__popup__cancel-icon search-change__cancel-icon">×</span><span>キャンセル</span></a></p>
                  <div className="popup-headline">
                    <h2 className="popup-headline__title">スペースへのお問い合わせ</h2>
                    <p className="popup-headline__text">お問い合わせ内容を入力して、「送信する」ボタンを押してください。</p>
                  </div>
                  <div className="row">
                    <div className="odd-col__line clearfix">
                      <div className="col-sm-12 col-md-4">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">目的</span>
                        </h2>
                        <div className="request-select__area">
                          <span className="service-select">
                            <select defaultValue="" onChange={this.eventTypeDidChange.bind(this)} name="event_type" className="service-select__purpose">
                              {this.renderEventTypeOptions(room)}
                            </select>
                          </span>
                          {this.renderFormItemError("event_type")}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">区分</span>
                        </h2>
                        <div className="request-select__area">
                          <span className="service-select">
                            <select defaultValue="" onChange={this.useTypeDidChange.bind(this)} name="use_type" className="service-select__purpose">
                              {this.renderUseTypeOptions(room)}
                            </select>
                          </span>
                          {this.renderFormItemError("use_type")}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">人数</span>
                        </h2>
                        <div className="request-select__area">
                          <span className="service-select">
                            <select defaultValue="" onChange={this.capacityDidChange.bind(this)} name="capacity" className="service-select__purpose">
                              {this.renderCapacitySelect(room)}
                            </select>
                          </span>
                          {this.renderFormItemError("capacity")}
                        </div>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-xs-12">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span>
                          <span className="popup-form__title-text">ご利用予定日</span>
                        </h2>
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <label className="contact-calender__checkin">
                          <span className="popup-form__label">ご利用開始日(チェックイン)</span>
                          <input ref="startedAt" type="text" name="" className="js-inquiry-datepicker form-text servicse-form-text w100pa" placeholder="カレンダーから選択" readOnly={true} />
                        </label>
                        {this.renderFormItemError("started_at")}
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <label className="contact-calender__checkout">
                          <span className="popup-form__label">ご利用終了日(チェックアウト)</span>
                          <input ref="endedAt" type="text" name="" className="js-inquiry-datepicker form-text servicse-form-text w100pa" placeholder="カレンダーから選択" readOnly={true} />
                        </label>
                        {this.renderFormItemError("ended_at")}
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-xs-12">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span>
                          <span className="popup-form__title-text">予算</span>
                        </h2>
                        <div className="contact-slider__area js-slider__horizontal">
                          <div id="js-slider__range" ref="priceSlider"></div>
                          <div className="search-slider__pricebox clearfix">
                            <div className="fl">
                              <input ref="minPrice" type="text" name="min_budget" id="js-slider__min" className="search-slider__input" /><span className="search-slider__price">円 〜</span>
                              {this.renderFormItemError("min_budget")}
                            </div>
                            <div className="fr">
                              <input ref="maxPrice" type="text" name="max_budget" id="js-slider__max" className="search-slider__input" /><span className="search-slider__price">円</span>
                              {this.renderFormItemError("max_budget")}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-xs-12">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__optional">任意</span><span className="popup-form__title-text">内覧について</span>
                        </h2>
                          <p><input ref="needPreview" type="checkbox" value="true" id="need-preview" name="need_preview" /><label htmlFor="need-preview" className="form-checkbox__s">内覧を希望する</label></p>
                      </div>
                    </div>
                    <div className="odd-col__line clearfix">
                      <div className="col-xs-12">
                        <h2 className="popup-form__title">
                          <span className="icon-form icon-form__required">必須</span>
                          <span className="popup-form__title-text">お問い合わせ事項</span>
                        </h2>
                        <p className="popup-form__text">電話番号・メールアドレスなどの入力はお控えください。</p>
                        {inquiryToRequestMessage}
                        <textarea defaultValue="" onChange={this.contentDidChange.bind(this)} name="content" className="popup-form__textarea request-contact__textarea" placeholder="会社の10周年記念パーティーの会場として18時～22時で利用を検討していますが、空き枠と利用条件の確認の問い合わせになります。また下見は可能でしょうか？よろしくお願いします。"></textarea>
                        {this.renderFormItemError("content")}
                      </div>
                    </div>

                    <div className="ta-c mt10 mb40 clearfix">
                      <div className="col-xs-12">
                        <input type="submit" name="commit" value="送信する" className="button-blue pt15 pb15 w200" />
                      </div>
                    </div>

                  </div>
                </div>
              </form>
            </div>
          </div>
    		</div>
        <div className="md-overlay"></div>
      </div>
    );
  }

}
export default SMRoomInquiryFormView;



// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMRoomInquiryFormView.jsx